"use client";

import { Navbar } from "@/components/layout/Navbar";
import { Footer } from "@/components/layout/Footer";
import { useSubscriptionSync } from "@/hooks/useSubscriptionSync";
import { SubscriptionBanner } from "@/components/billing/SubscriptionBanner";
import { TrialConversionModal } from "@/components/billing/TrialConversionModal";
import { useTrialConversionPrompt } from "@/hooks/useTrialConversionPrompt";

export default function DashboardLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  // Sync subscription state from Polar.sh on authenticated page load.
  // Ensures entitlements persist across logins without a fresh webhook.
  useSubscriptionSync();

  // Proactively prompt trialing users to subscribe when ≤ 3 days remain.
  const trialPrompt = useTrialConversionPrompt();

  return (
    <div className="flex min-h-screen flex-col bg-background">
      <Navbar />
      {/* Subscription alerts: trial ending, past-due, canceling, grace period */}
      <SubscriptionBanner />
      <main className="flex-1 px-4 py-8">
        <div className="mx-auto max-w-6xl">{children}</div>
      </main>
      <Footer />
      {/* Proactive trial-expiry modal (fires when ≤ 3 days remain on free trial) */}
      <TrialConversionModal
        open={trialPrompt.isOpen}
        onClose={trialPrompt.dismiss}
        variant="trial_expiring"
      />
    </div>
  );
}
